<template>
    <div>
        <form-response-errors ref="formResponseErrors" :reload="reload"></form-response-errors>

        <div class="row" v-if="locality.id">
            <div class="col-lg-6 col-xl-4">

                <div class="card card-primary card-outline" :class="{'card-danger': locality.deleted_at }">
                    <div class="card-body box-profile">
                        <div class="text-center">
                            <i v-if="locality.deleted_at" class="fas fa-trash-alt fa-2x text-danger"></i>
                            <i v-else class="fas fa-city fa-2x"></i>
                        </div>

                        <h3 class="profile-username text-center">{{ locality.name }}</h3>
                        <p v-if="locality.type" class="text-muted text-center mb-0">
                            {{ locality.type.name }}
                        </p>

                        <ul class="list-group list-group-unbordered mt-3 mb-3">
                            <li class="list-group-item" v-if="locality.region">
                                <b>{{ trans("locality.Region") }}</b>
                                <router-link v-if="can('read-region')"
                                             :to="{name: 'region-detail', params: {id: locality.region.id}}"
                                             class="float-right">
                                    {{ locality.region.name }}
                                </router-link>
                                <span v-else class="float-right">{{ locality.region.name }}</span>
                            </li>
                        </ul>

                        <router-link v-if="can('update-locality')"
                                     :to="{name: 'locality-edit', params: {id: locality.id}}"
                                     class="btn btn-sm btn-primary mr-1">
                            <i class="fas fa-pencil-alt"></i>
                        </router-link>

                        <template v-if="can('create-locality')">
                            <router-link :to="{ name: 'locality-clone', params: { id: locality.id } }"
                                         class="btn btn-sm btn-primary mr-1">
                                <i class="fas fa-clone"></i>
                            </router-link>
                        </template>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LocalityService from "../../services/LocalityService";

export default {
    props: ['id'],
    data() {
        return {
            locality: {},
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        reload() {
            this.getData();
        },
        async getData() {
            try {
                this.$refs.formResponseErrors.hide();
                let response = await LocalityService.getDetail(this.id, this.can('deleted-locality-read'));
                this.locality = response.data.data;
                this.$store.dispatch("breadcrumbs/setTitle", this.locality.name);
            } catch (error) {
                this.$refs.formResponseErrors.show(error);
            }
        }
    }
}
</script>
